import { EmailCustomization } from '../../../api/configurations/customization/types';

export enum EmailTypes {
  registrationConfirm = 'registrationConfirm',
  welcome = 'welcome',
  verificationCode = 'verificationCode',
  verificationLinkCode = 'verificationLinkCode',
  passwordChange = 'passwordChange',
  emailChange = 'emailChange',
  blockedAccount = 'blockedAccount',
  mfaCode = 'mfaCode',
  mfaSettingsChange = 'mfaSettingsChange',
  newsSubscribe = 'newsSubscribe',
  custom = 'custom'
}

export type EmailPreviewState = {
  emailCustomization: EmailCustomization | null;
  fetching: boolean;
  submitting: boolean;
  isPreview: boolean;
  emailType: EmailTypes;
  inputError: string;
  submitError: boolean;
};

export enum ActionType {
  getEmailsSuccess = 'getEmailsSuccess',
  getEmailsFail = 'getEmailsFail',
  updateEmails = 'updateEmails',
  setEmailType = 'setEmailType',
  changePreview = 'changePreview',
  changeInputError = 'changeInputError',
  submitStarted = 'submitStarted',
  submitSuccess = 'submitSuccess',
  submitFailed = 'submitFailed'
}

export type Action = {
  type: ActionType;
  payload?: unknown;
};
